<template>
  <!-- 此模块未入网弹框 -->
  <div class="no-access-dialog">
    <van-popup v-model="showDialog" :close-on-click-overlay="false">
      <div class="content">
        <div class="title"> {{ type === 0 ? '未入网提醒' : '车机检修提醒' }} </div>
        <div class="no-access-box font-24" v-if="type === 0">
          <p>您所查车辆未在《道路货运公共平台》办理入网或入网已过期，如需定位请先完成车辆入网。</p>
          <div class="reason font-24" @click="goReasonBtn">为什么要办理入网?</div>
        </div>
        <div class="overhaul-box font-24" v-else>
          <div class="overhaul-title">
            车辆车机终端长时间离线，请检查修复终端设备，通常离线原因有：
          </div>
          <div class="overhaul-content">
            <p>1.终端SIM卡停机欠费，每月初常见；</p>
            <p>2.车机终端故障或设备已损坏；</p>
            <p>3.车机电源松动。</p>
          </div>
          <div class="overhaul-bottom">推荐处理：联系终端安装服务商</div>
        </div>
        <div class="btn" @click="showDialog=false">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { wxNavigateTo } from '../../utils/WeChatUtil'
export default {
  props: {
    type: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  data() {
    return {
      showDialog: false, // 是否显示未入网弹框
    }
  },
  methods: {
    showPopup () {
      this.showDialog = true
    },
    goReasonBtn () {
      if (this.isWechart) {
        wxNavigateTo('/pages/netReason/index')
      }
    }
  }
};
</script>

<style scoped lang="scss">
.no-access-dialog>:nth-child(1) {
  background-color: rgba(0,0,0,.4)
}
.no-access-dialog>:nth-child(2) {
  width: 70%;
  border-radius: 12px;
  .content {
    padding: 40px 50px;
    .title {
      font-size: 32px;
      color: #646464;
      font-weight: bold;
      padding: 20px 0 30px;
      text-align: center;
    }
    .no-access-box {
      color: #979797;
      .reason {
        padding-top: 30px;
        text-align: center;
        color: #5572FC;
        text-decoration: underline;
      }
    }
    .overhaul-box {
      color: #979797;
      .overhaul-title {
        padding-bottom: 40px;
      }
      .overhaul-bottom {
        padding: 40px 0 10px;
      }
    }
    .btn {
      background-color: #5572FC;
      border-radius: 4px;
      margin: 30px 20px 0;
      padding: 20px 0;
      text-align: center;
      font-size: 28px;
      color: #ffffff;
    }
    .font-24 {
      font-size: 24px;
    }
  }
}
</style>
